import React from 'react';
import Styled from './styles';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
const styles = () => ({
  button: {
    marginLeft: 10,
    backgroundColor: '#42FFBB',
    color: 'black',
    fontSize: 14,
    fontWeight: 900,
    borderRadius: 8,
    padding: '15px',
    '&:hover': {
      backgroundColor: '#42FFBB'
    }
  }
});
class LinkGenerated extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { onToggle, salesLink, classes, mode } = this.props;
    return (
      <Styled.LinkGeneratedContainer>
        <Styled.Title>Payment link generated successfully</Styled.Title>
        <Styled.Description>
          Your payment link is generated! Now ensure continuous follow up with
          the customer till the payment is closed!
        </Styled.Description>
        <Styled.Text>You Rock {String.fromCodePoint(0x1f60e)}</Styled.Text>
        <Styled.Label>Here is your payment link-</Styled.Label>
        <Styled.Link href={salesLink} target="_blank">
          {salesLink}
        </Styled.Link>
        <Button
          classes={{ root: classes.button }}
          onClick={() => navigator.clipboard.writeText(salesLink)}
        >
          Copy Link
        </Button>
        <Styled.Create onClick={onToggle}>
          Create another {mode} link
        </Styled.Create>
      </Styled.LinkGeneratedContainer>
    );
  }
}
export default withStyles(styles)(LinkGenerated);



// WEBPACK FOOTER //
// ./src/pages/SalesUtility/LinkGenerated/index.js